import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getLanguageCode } from 'modules/meta/selectors';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Brand } from '@daedalus/core/src/brand/types';
import { TrustpilotWidget } from '@daedalus/shared/src/search/footer/TrustpilotWidget';
import { FooterCopyrightSection } from './CopyrightSection/CopyrightSection';
import { FooterGetTheAppSection } from './GetTheAppSection/GetTheAppSection';
import { FooterLinksSection } from './LinksSection/LinksSection';
import { FooterSocialSection } from './SocialSection/SocialSection';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w19k5p5w",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ContentWrapper;
const FooterCopyrightWrapper = /*#__PURE__*/styled(_exp2())({
  name: "FooterCopyrightWrapper",
  class: "fpsz0js",
  propsAsIs: true
});
interface Props {
  brand: Brand;
}
export const Footer = ({
  brand
}: Props) => {
  const {
    isMobile,
    isDesktopXs
  } = useDeviceLayout();
  const lang = useSelector(getLanguageCode);
  const isSingleColumn = isMobile || isDesktopXs;
  return <Wrapper>
      <ContentWrapper paddingX="s600" paddingY="s900">
        <StyledContentWrapper paddingBottom="s600">
          <Flex.Row justifyContent="space-between">
            <LayoutContainer>
              <FooterLinksSection brand={brand} />
              {isSingleColumn && <Flex.Row justifyContent="center">
                  <TrustpilotWidget lang={lang} variant="horizontal" theme="dark" />
                </Flex.Row>}
              <FooterSocialSection brand={brand} isSingleColumn={isSingleColumn} />
              <FooterGetTheAppSection isSingleColumn={isSingleColumn} />
            </LayoutContainer>
            {!isSingleColumn && <TrustpilotWidget lang={lang} variant="mini" theme="dark" />}
          </Flex.Row>
        </StyledContentWrapper>
        <FooterCopyrightWrapper paddingTop="s800">
          <FooterCopyrightSection brand={brand} />
        </FooterCopyrightWrapper>
      </ContentWrapper>
    </Wrapper>;
};
const _exp5 = /*#__PURE__*/() => ContentWrapper;
const StyledContentWrapper = /*#__PURE__*/styled(_exp5())({
  name: "StyledContentWrapper",
  class: "sepdxhr",
  propsAsIs: true
});
const LayoutContainer = /*#__PURE__*/styled('div')({
  name: "LayoutContainer",
  class: "l8wmwy3",
  propsAsIs: false
});

require("./Footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Footer.tsx");